export const GUEST_USER = 'Guest';
export interface CouponUser {
  isLoggedIn: boolean;
  ppc: string;
  name: string;
}

export const couponUser: CouponUser = {
  isLoggedIn: false,
  ppc: '',
  name: GUEST_USER,
};
